import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

const MIN_DISPLAY_TIME = 6000;

export default function OnboardingLoading({ onCreateDemoGame, gameCreated }) {
  const navigate = useNavigate();
  const hasStarted = useRef(false);
  const mountTime = useRef(Date.now());
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (onCreateDemoGame && !gameCreated && !hasStarted.current) {
      hasStarted.current = true;
      onCreateDemoGame();
    }
  }, [onCreateDemoGame, gameCreated]);

  useEffect(() => {
    if (gameCreated && !isReady) {
      const elapsed = Date.now() - mountTime.current;
      const remaining = Math.max(0, MIN_DISPLAY_TIME - elapsed);

      setTimeout(() => {
        setIsReady(true);
      }, remaining);
    }
  }, [gameCreated, isReady]);

  useEffect(() => {
    if (isReady) {
      navigate('/classification/level/1/tutorial?onboarding=true');
    }
  }, [isReady, navigate]);

  return (
    <div className="onboarding-loading-demo">
      <h1>Loading Demo</h1>
      <div className="onboarding-loading-demo-bar">
        <div className="onboarding-loading-demo-bar-fill"></div>
      </div>
      <h2>The Account Classification Exercise</h2>
      <p>A multi-level exercise that starts with sorting the 5 Elements and then sorting Accounts to the Elements.</p>
    </div>
  );
}
